export var MAX_MOBILE_VISIBLE_SHADES_COUNT = 7;
export var MAX_DESKTOP_VISIBLE_SHADES_COUNT = 10;
export var PRODUCT_BOX_SHADE_TEST_ID = 'product-box-shade';
//# sourceMappingURL=constants.js.map